<script setup lang="ts">
import { MetricType, getMetricImage } from './utility';
import ValueTile from './parts/ValueTile.vue';
import { MeasureResult, MetricValue } from '../../utils/types';
import { lowercaseNoSpaces } from '@Shared/components/visuals/utility';

const props = defineProps<{
  title?: string;
  measureResult?: MeasureResult;
  isLoadingIndicator?: boolean;
  metricType?: MetricType;
  metricBreakdown?: {
    negative: MeasureResult;
    neutral: MeasureResult;
    positive: MeasureResult;
  };
  borderHighlight?: string;
}>();

const { title, metricBreakdown, measureResult, metricType } = toRefs(props);

const scores = computed<MetricValue[]>(() => {
  if (!metricBreakdown.value || !measureResult.value) return [];

  return [
    { label: '-1', value: metricBreakdown.value.negative.currentValue, metricType: MetricType.Count },
    { label: '0', value: metricBreakdown.value.neutral.currentValue, metricType: MetricType.Count },
    { label: '1', value: metricBreakdown.value.positive.currentValue, metricType: MetricType.Count },
    {
      label: measureResult.value.label!,
      value: measureResult.value.currentValue,
      metricType: metricType.value!,
    },
  ];
});
</script>
<template>
  <ValueTile
    class="m-2 rounded-1 overflow-hidden"
    :id="`MetricBreakdownTile_${lowercaseNoSpaces(title)}`"
    :loading="isLoadingIndicator"
    :title="title"
    :scores="scores"
    :style="{ 'box-shadow': `0px 0px 20px 0px ${borderHighlight}` }"
  >
    <template #header="{ score }">
      <span v-if="score.label == measureResult?.label"> {{ score.label }} </span>
      <component class="w-40% h-full max-w-12px" :is="getMetricImage(Number(score.label))" v-else></component>
    </template>
    <template #data="{ value, index }"
      ><span
        class="text-3 xl:text-4"
        :class="{
          // make the last score bold since it's the measure result
          'font-medium': index == scores.length - 1,
        }"
        >{{ value }}</span
      ></template
    >
  </ValueTile>
</template>
